import { API } from '@/shared/plugins/Api/API'

class SparkHistory extends API {
  // Returns { status: STOPPED|PROVISIONING|RUNNING, running, namespace, shortname }
  status () {
    return this.request({
      method: 'get',
      url: 'v3/spark-history'
    })
  }

  // Provisioning is asynchronous (202): the final state is published through
  // the websocket event forepaas.dpe.spark_history.status.update
  // options: { dpu } — server size, persisted server side for the next starts
  start (options = {}) {
    return this.request({
      method: 'post',
      url: 'v3/spark-history/start',
      data: options
    })
  }

  stop () {
    return this.request({
      method: 'delete',
      url: 'v3/spark-history'
    })
  }

  // Returns { applications (total), size (bytes), last_event_at, applications_list (page), running }
  // applications_list is paged server-side: offset/limit (limit capped server-side)
  stats ({ offset = 0, limit } = {}) {
    const params = {}
    if (offset) params.offset = offset
    if (limit) params.limit = limit
    return this.request({
      method: 'get',
      url: 'v3/spark-history/stats',
      params
    })
  }

  // Per-project settings: { enabled?, retention_days?, max_applications? }
  setEventlogs (settings) {
    return this.request({
      method: 'put',
      url: 'v3/spark-history/eventlogs',
      data: settings
    })
  }

  // Retention is enforced daily; this applies it now (async server side)
  applyEventlogsRetention () {
    return this.request({
      method: 'post',
      url: 'v3/spark-history/eventlogs/apply'
    })
  }
}

export default SparkHistory

export {
  SparkHistory
}
